module.exports = __webpack_public_path__ + "static/media/wallet_onboarding_02.d539f7b8.svg";